import { useQuery } from "@tanstack/react-query";
import AuthService from "../services/auth.service";

export function useUser() {
  const { isLoading, data: user } = useQuery({
    queryKey: ["user"],
    queryFn: AuthService.getCurrentUser,
  });

  return {
    isLoading,
    user,
    isSuperAdmin: user?.role === "superadmin",
    isAdminAuthenticated: user?.role === "admin" || user?.role === "superadmin",
    isUserAuthenticated: !!user,
  };
}
